import { Getter, Setter } from 'jotai';

import { PaginationRequest, PaginationResponse } from 'data/common/models';
import { map } from 'utils/remote';

import { DataAtom } from './dataAtom';
import { setFetchingErrorStatus } from './dataFetchingAtom';

export const fetchPagination =
  <T, F extends object>(
    pagesAtom: DataAtom<PaginationResponse<never>>,
    fetcher: (request: PaginationRequest<F>) => Promise<PaginationResponse<T>>,
  ) =>
  async (request: PaginationRequest<F>, _: Getter, set: Setter) => {
    try {
      if (request.reloadPages) {
        set(pagesAtom, { fetchStatus: 'LOADING' });
      }
      set(pagesAtom, (value) =>
        map(value, (value) => ({
          ...value,
          currentPage: request.page ?? value.currentPage,
        })),
      );

      const { items, ...pages } = await fetcher(request);

      set(pagesAtom, {
        fetchStatus: 'SUCCESS',
        data: {
          items: [],
          ...pages,
        },
      });
      return items;
    } catch (error) {
      setFetchingErrorStatus(set, pagesAtom, error);
      throw error;
    }
  };
